import raw from './contact.json';

export interface ContactConfig {
  /** Full LINE add-friend URL, e.g. https://lin.ee/xxxx */
  lineUrl: string;
  /** Displayed LINE ID, e.g. @happytech */
  lineId: string;
  /** E.164 or local format; used for the tel: href */
  phone: string;
  email: string;
  /** Public profile URLs for schema.org sameAs */
  sameAs: string[];
}

/**
 * Contact channels. Any field left empty is treated as not configured and
 * its UI is hidden rather than rendered as a dead link.
 */
export const contact: ContactConfig = raw;

export const hasLine = Boolean(contact.lineUrl);
export const hasPhone = Boolean(contact.phone);
export const hasEmail = Boolean(contact.email);

/** Strip spaces and dashes so tel: dials correctly. */
export const telHref = contact.phone.replace(/[\s-]/g, '');
